module.exports = __webpack_public_path__ + "static/media/timelydeals.d39caeee.png";